import { Avatar, Box, HStack, Text } from '@chakra-ui/react';
import moment from 'moment';
import IsDesktop from '../../../utils/IsDesktop';
import { useDispatch, useSelector } from 'react-redux';
import { setTotalNotificationCount, setUnreads } from '../../../redux-toolkit/reducers/userSlice';
import UserService from '../../../utils/UserService';
import { mutateFunction, useMutation } from '../../../libs/apis';

const ConnectionMessage = ({ message, openChatBox, recipient }) => {
  const isDesktop = IsDesktop();
  const recipientId = recipient?.id || 0;
  const messages = useSelector(
    (state) => state?.usermessages?.messages[`${recipientId}`] || [],
  );
  const { mutate, isLoading } = useMutation(mutateFunction);
  const unreads = useSelector((state) => state?.user?.unreads || null);
  const totalNotificationCount = useSelector((state) => state?.user?.totalNotificationCount || 0);
  const dispatch = useDispatch()

  const lastMessage =
    messages[messages?.length - 1] || recipient?.lastMessage || null;

  const getLastTimeStamp = () => {
    let time = moment(
      recipient?.last_seen ||
      lastMessage?.createdAt ||
      recipient?.date_accepted ||
      recipient?.created_at,
    ).fromNow();
    return time || 'Just Now';
  };

  const readNotification = (notificationId) => {
    try {
      mutate(
        {
          key: `users/${notificationId}/notification`,
          method: 'post',
        },
        {
          onSuccess(res) { },
        },
      );
    } catch (error) {

    }
  };

  return (
    <>
      <Box
        onClick={() => {
          const idsOfCurrentMessages = unreads?.[recipient.id]?.ids || []

          const numberOfCurrentMessages = idsOfCurrentMessages.length || 0
          if (unreads) {
            dispatch(setUnreads({
              ...unreads,
              [recipient.id]: {
                count: 0,
                ids: [],
                senderIds: []
              }
            }))
          }

          dispatch(setTotalNotificationCount(totalNotificationCount - numberOfCurrentMessages))
          UserService.setNotificationCurrentCount(totalNotificationCount - numberOfCurrentMessages)
          for (let _id of idsOfCurrentMessages) {
            readNotification(_id)
          }
          openChatBox(recipientId, recipient)

        }}
        borderRadius={4}
        //   bg={index === recipient ? "#F5F5F5" : "#fff"}
        bg="#white"
        _hover={{ backgroundColor: '#F5F5F5' }}
        borderTop="1px solid rgba(19, 74, 112, 0.2)"
        cursor="pointer"
      >
        <HStack p={3} className="relative w-full">
          <Avatar
            name={`${recipient?.first_name} ${recipient?.last_name}`}
            src={recipient?.profile_image || undefined}
            alt="Avatar"
            w="48px"
            h="48px"
            borderRadius="100%"
          />
          <Box className="max-w-[60%]" p={2} pl={4} flex={1}>
            <Text fontSize={15} fontWeight={500}>
              {recipient?.first_name} {recipient?.last_name}
            </Text>
            {!isDesktop && (
              <Text
                className="max-w-[250px]"
                textOverflow="ellipsis"
                whiteSpace="nowrap"
                fontSize={12}
                fontWeight={500}
                color="#062F36"
                pr={2}
              >
                {lastMessage && lastMessage?.content?.length > 18
                  ? `${lastMessage?.content?.substring(0, 20)}...`
                  : lastMessage?.content}
              </Text>
            )}
            {isDesktop && (
              <Text
                className="max-w-[250px]"
                textOverflow="ellipsis"
                whiteSpace="nowrap"
                fontSize={12}
                fontWeight={500}
                color="#062F36"
                pr={2}
              >
                {lastMessage && lastMessage?.content?.length > 18
                  ? `${lastMessage?.content?.substring(0, 20)}...`
                  : lastMessage?.content}
              </Text>
            )}
          </Box>
          <Box p={2} className="absolute flex gap-4 items-center flex-col space-between right-0 top-1">
            <Text fontSize={10} color="#134A70" fontWeight={500}>
              {getLastTimeStamp()}
            </Text>
            {
              unreads && unreads[recipient?.id] && unreads[recipient?.id]?.count > 0 ? (
                <Box className='h-2 w-2 rounded-full bg-green-300'></Box>
              ) : null
            }
          </Box>
        </HStack>
      </Box>
    </>
  );
};
export default ConnectionMessage;
